export const normalizeBookings = (data) => {
  if (Array.isArray(data)) return data;
  return data?.bookings || data?.items || [];
};

export const filterBookings = (bookings, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return bookings;

  return bookings.filter((booking) => {
    const name = (booking?.customerSnapshot?.name || booking?.fullName || "").toLowerCase();
    const company = (booking?.customerSnapshot?.companyName || booking?.companyName || "").toLowerCase();
    const phone = (booking?.customerSnapshot?.phoneNumber || booking?.phoneNumber || "").toLowerCase();
    const registration = (booking?.vehicleSnapshot?.registrationNumber || "").toLowerCase();
    const status = (booking?.status || "").toLowerCase();

    return (
      name.includes(term) ||
      company.includes(term) ||
      phone.includes(term) ||
      registration.includes(term) ||
      status.includes(term)
    );
  });
};

export const formatBookingDateTime = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-PK", {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const formatBookingAmount = (amount) => {
  const numericAmount = Number(amount);
  if (!Number.isFinite(numericAmount)) return "-";
  return new Intl.NumberFormat("en-PK", {
    style: "currency",
    currency: "PKR",
    maximumFractionDigits: 0,
  }).format(numericAmount);
};

export const getBookingStatusBadgeClass = (status) => {
  if (status === "completed") return "badge bg-success";
  if (status === "pending") return "badge bg-warning text-dark";
  if (status === "in_progress") return "badge bg-primary";
  if (status === "cancelled") return "badge bg-danger";
  return "badge bg-secondary";
};
